import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { Overline, Reveal } from "./Reveal";
import { WHATSAPP_URL, trackClick } from "../../lib/site";

const FAQS = [
  {
    q: "Você atende por convênio médico?",
    a: "Meus atendimentos são exclusivamente particulares, o que me permite oferecer um suporte mais humanizado, profundo e dedicado a cada paciente. No entanto, posso emitir o recibo para que você solicite o reembolso junto ao seu plano de saúde, caso ele ofereça essa modalidade.",
  },
  {
    q: "Como funciona a primeira sessão?",
    a: "O primeiro encontro é um espaço para nos conhecermos. Você poderá compartilhar o que te levou a buscar terapia e avaliaremos juntos o melhor caminho para o seu acompanhamento.",
  },
  {
    q: "A terapia online tem a mesma eficácia que a presencial?",
    a: "Sim, totalmente. A psicoterapia online é reconhecida e regulamentada pelo Conselho Federal de Psicologia (CFP) e apresenta os mesmos resultados científicos da modalidade presencial, com o benefício extra da flexibilidade, do conforto e da economia de tempo com deslocamento.",
  },
  {
    q: "E se eu começar a terapia e sentir que não era o que eu esperava?",
    a: "É natural ter essa dúvida, especialmente se esta for sua primeira experiência com a terapia. O processo terapêutico é construído em conjunto e inclui um espaço para conversar abertamente sobre suas expectativas, percepções e necessidades ao longo do caminho. Se, em algum momento, algo não fizer sentido para você, isso pode e deve ser levado para a sessão. A terapia também é um lugar para refletirmos sobre essas experiências, avaliarmos o percurso e, juntos, decidirmos os próximos passos.",
  },
  {
    q: "Qual é o valor da sessão?",
    a: "Por uma questão de ética profissional, os valores não são divulgados publicamente. Me chame no WhatsApp, conte o que você está buscando e eu explico como funciona o acompanhamento, os valores e as formas de pagamento. O primeiro contato é só uma conversa — sem custo e sem compromisso.",
  },
];

export const Faq = () => (
  <section id="duvidas" data-testid="faq-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-3xl px-6">
      <Reveal>
        <Overline>Dúvidas frequentes</Overline>
        <h2 className="mt-6 font-serif text-3xl font-normal leading-tight tracking-tight text-bark sm:text-4xl lg:text-5xl">
          Perguntas antes de agendar
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b border-bark/10"
            >
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-6 text-left font-serif text-xl font-medium text-bark transition-colors duration-300 hover:text-brand hover:no-underline sm:text-2xl"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-answer-${i}`}
                className="pb-6 text-base leading-relaxed text-moss"
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-col items-center gap-5 rounded-[2rem] bg-bone/60 px-8 py-10 text-center">
          <p className="font-serif text-2xl font-medium text-bark sm:text-3xl">
            Ainda ficou com alguma dúvida?
          </p>
          <a
            data-testid="faq-cta"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick("faq")}
            className="rounded-full bg-brand px-8 py-4 text-sm font-semibold text-sand shadow-[0_16px_36px_rgba(58,77,57,0.28)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:bg-brand-deep"
          >
            Me chame no WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
